// extracted by mini-css-extract-plugin
export default {"icon":"HistoryItemDate__icon___NkLyI"};